import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledServiceThumbnailsGrid {}

const StyledServiceThumbnailsGrid = styled.div<IStyledServiceThumbnailsGrid>`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-gap: ${rem(`16px`)};
  align-items: stretch;
  justify-content: space-evenly;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  ${({ theme }) => theme.breakpoints.phone`
    grid-template-columns: repeat(2, 1fr);
  `}
  ${({ theme }) => theme.breakpoints.tablet`
    grid-template-columns: repeat(3, 1fr);
  `}
  ${({ theme }) => theme.breakpoints.desktop`
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
    grid-gap: ${rem(`32px`)};
  `}
`;

interface IServiceThumbnailsGrid {
  children: any;
  className?: string;
}

export const ServiceThumbnailsGrid = ({
  children,
  className,
}: IServiceThumbnailsGrid) => {
  return (
    <StyledServiceThumbnailsGrid className={className}>
      {children}
    </StyledServiceThumbnailsGrid>
  );
};
